export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAHElEQVR42mNgYGD4TyEGEeVk4lEDRg2grgHkYwBaZQBk5YuEDgAAAABJRU5ErkJggg=="